import * as Yup from "yup";
import {
  CCM_CONSENT_TEXT,
  OTHER_MODALITY_FIELD,
  PATIENT_FIELDS,
  VISIT_MODALITY,
  ZIP_CODE_REGEX,
} from "./ccm-consent-constant";
import { CONSENT_VALIDATION_TEXT } from "./ccm-consent-copy-constant";

const [FIRST_NAME_FIELD, LAST_NAME_FIELD, DATE_OF_BIRTH_FIELD] = PATIENT_FIELDS;

export const consentAcknowledgementSchema = Yup.object({
  patientSignature: Yup.string().when("responsiblePersonSignature", {
    is: (signature?: string) => !signature,
    then: (schema) =>
      schema.required(CONSENT_VALIDATION_TEXT.SIGNATURE_REQUIRED),
  }),
  relationshipToPatient: Yup.string().when("responsiblePersonSignature", {
    is: (signature?: string) => !!signature,
    then: (schema) =>
      schema.trim().required(CONSENT_VALIDATION_TEXT.RELATIONSHIP_REQUIRED),
  }),
});

export const ccmConsentSchema = Yup.object({
  patient: Yup.object({
    firstName: Yup.string().trim().required().label(FIRST_NAME_FIELD.label),
    lastName: Yup.string().trim().required().label(LAST_NAME_FIELD.label),
    dateOfBirth: Yup.string()
      .nullable()
      .required()
      .label(DATE_OF_BIRTH_FIELD.label),
    gender: Yup.string().required().label(CCM_CONSENT_TEXT.GENDER),
    zipCode: Yup.string().matches(ZIP_CODE_REGEX, {
      message: CCM_CONSENT_TEXT.ZIP_CODE_ERROR,
      excludeEmptyString: true,
    }),
  }),
  releaseAuthorization: Yup.object({
    expiry: Yup.string().required(CONSENT_VALIDATION_TEXT.EXPIRY_REQUIRED),
  }),
  consentDocumentation: Yup.object({
    patientSignature: Yup.string().test(
      "patient-or-guardian-signature",
      CONSENT_VALIDATION_TEXT.SIGNATURE_REQUIRED,
      function (signature) {
        const root = this.from?.[this.from.length - 1]?.value;
        return (
          !!signature || !!root?.acknowledgement?.responsiblePersonSignature
        );
      }
    ),
  }),
  acknowledgement: consentAcknowledgementSchema,
  telehealth: Yup.object({
    otherModality: Yup.string().when("visitModality", {
      is: VISIT_MODALITY.OTHER,
      then: (schema) =>
        schema.trim().required().label(OTHER_MODALITY_FIELD.label),
    }),
  }),
});
